export default {
  "menu.login": "登入",
  "menu.dashboard": "首頁",
  "menu.aiRecommendation": "AI 建議歷史",
  "menu.analytics": "智慧分析",
  "menu.stock": "庫存查看",
  "menu.transaction": "出入庫",
  "menu.inventoryCheck": "盤點",
  "menu.product": "商品管理",
  "menu.contact": "往來單位",
  "menu.settings": "設定",
  "menu.pricing": "方案",
  "menu.account.logout": "登出",

  // hideInMenu（側欄不顯示，但需要麵包屑/標題文案）
  "menu.aiLineSetup": "LINE 綁定",
  "menu.aiMonthlyReport": "月度報告",
};
